var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import format from 'date-fns/format';
import formatDistance from 'date-fns/formatDistance';
import memoize from 'memoize-one';
import * as React from 'react';
import { getDateFnsLocale } from '../../util-components/datetime';
export var DatetimeFormat;
(function (DatetimeFormat) {
    DatetimeFormat["Short"] = "Short";
    DatetimeFormat["ShortNoTime"] = "ShortNoTime";
    DatetimeFormat["ShortWithRelative"] = "ShortWithRelative";
    DatetimeFormat["ShortNoTimeWithRelative"] = "ShortNoTimeWithRelative";
    DatetimeFormat["Long"] = "Long";
    DatetimeFormat["LongNoTime"] = "LongNoTime";
    DatetimeFormat["LongWithRelative"] = "LongWithRelative";
    DatetimeFormat["LongNoTimeWithRelative"] = "LongNoTimeWithRelative";
    DatetimeFormat["ShortWithRelativeLogStyle"] = "ShortWithRelativeLogStyle";
})(DatetimeFormat || (DatetimeFormat = {}));
var shortFormat = 'PPp';
var longFormat = 'PPPp';
var shortFormatNoTime = 'PP';
var longFormatNoTime = 'PPP';
var Datetime = /** @class */ (function (_super) {
    __extends(Datetime, _super);
    function Datetime(props) {
        var _this = _super.call(this, props) || this;
        _this.getDateRepresentation = memoize(function (dateValue, dateFormat) {
            var dateAndTime = dateValue.split('T');
            var dateSplit = dateAndTime[0].split('-');
            var time = dateAndTime[1].split('+');
            var timeOnly = time[0].split(':');
            var date = new Date(Number(dateSplit[0]), Number(dateSplit[1]) - 1, Number(dateSplit[2]), Number(timeOnly[0] || 0), Number(timeOnly[1] || 0), Number(timeOnly[2] || 0));
            var localTime = _this.props.ignoreTimeZone ? date : new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000));
            var today = new Date();
            var locale = getDateFnsLocale();
            switch (dateFormat) {
                case DatetimeFormat.Short: {
                    var finalDate = format(localTime, shortFormat, { locale: locale });
                    return finalDate;
                }
                case DatetimeFormat.ShortNoTime: {
                    return format(localTime, shortFormatNoTime, { locale: locale });
                }
                case DatetimeFormat.ShortWithRelative:
                case DatetimeFormat.ShortNoTimeWithRelative: {
                    var datetime = format(localTime, dateFormat === DatetimeFormat.ShortNoTimeWithRelative ? shortFormatNoTime : shortFormat, { locale: locale });
                    var distance = formatDistance(localTime, today, { addSuffix: true, locale: locale });
                    return datetime + " (" + distance + ")";
                }
                case DatetimeFormat.Long: {
                    return format(localTime, longFormat, { locale: locale });
                }
                case DatetimeFormat.LongNoTime: {
                    return format(localTime, longFormatNoTime, { locale: locale });
                }
                case DatetimeFormat.LongWithRelative:
                case DatetimeFormat.LongNoTimeWithRelative: {
                    var fmt = dateFormat === DatetimeFormat.LongNoTimeWithRelative ? longFormatNoTime : longFormat;
                    var datetime = format(new Date(dateValue), fmt, { locale: locale });
                    var distance = formatDistance(localTime, new Date(), { addSuffix: true, locale: locale });
                    return datetime + " (" + distance + ")";
                }
                case DatetimeFormat.ShortWithRelativeLogStyle: {
                    var datetime = format(localTime, shortFormat, { locale: locale });
                    var distance = formatDistance(localTime, today, { addSuffix: true, locale: locale });
                    return (React.createElement(React.Fragment, null,
                        React.createElement("span", null, distance),
                        " ",
                        React.createElement("br", null),
                        " ",
                        React.createElement("span", null, datetime)));
                }
                default:
                    throw new Error("Datetime format " + _this.props.format + " is not recognised.");
            }
        });
        _this.getMinutes = function (date) { return (date.getMinutes() < 10 ? '0' : '') + date.getMinutes(); };
        _this.state = {
            value: new Date(_this.props.value),
        };
        return _this;
    }
    Datetime.prototype.render = function () {
        return this.getDateRepresentation(this.props.value, this.props.format ? this.props.format : Datetime.defaultProps.format);
    };
    Datetime.MONTH_LONG_TRANSLATION_KEY_BASE = 'ui_component.date.month.long.';
    Datetime.MONTH_SHORT_TRANSLATION_KEY_BASE = 'ui_component.date.month.short.';
    Datetime.defaultProps = {
        format: DatetimeFormat.Short,
    };
    return Datetime;
}(React.Component));
export default Datetime;
//# sourceMappingURL=index.js.map